import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-06/task-03";

const task: Slide = {
  titleHtml:
    "A baffled plane piston of radius a radiates a sound of frequency. <br /> For which configuration at least one secondary lobe will appear?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
